import { useCallback, useState } from 'react'

export type SessionStorageKey =
  | 'hubloOffersFilterSelectedNetworks'
  | 'institutionPresentationFrom'
  | 'selectedSignupCode'
  | 'hublerOnboardingContext'
type SessionStorageHook = [string | null, (value: string) => void, () => void]

export const useSessionStorage = (
  key: SessionStorageKey,
): SessionStorageHook => {
  const [storageState, setStorageState] = useState<string | null>(
    sessionStorage.getItem(key),
  )

  const setSessionStorageState = useCallback(
    (value: string) => {
      setStorageState(value)
      sessionStorage.setItem(key, value)
    },
    [key],
  )

  const resetSessionStorageState = useCallback(() => {
    sessionStorage.removeItem(key)
    setStorageState(null)
  }, [key])

  return [storageState, setSessionStorageState, resetSessionStorageState]
}
